<template>
  <div class="nav">
    <div
      class="title-n-view"
      :style="{
        height: navHeight + 'px',
        opacity: $route.meta.titleNView ? opacity : 1
      }"
    >
      <div
        class="nav-bar"
        :style="{
          height: navHeight + 'px',
          paddingTop: statusBarHeight + 'px'
        }"
      >
        <van-icon class="arrow" @click="goBack" name="arrow" size="17.5px" />
        {{ title }}
        <div class="right-warp">
          <img
            v-if="
              !$route.meta.no_home && !['home', 'cart'].includes($route.name)
            "
            src="@/assets/images/home/home_logo_black.png"
            @click="goHome"
            alt=""
          />
        </div>
      </div>
    </div>
    <div
      class="nav-bar"
      :class="{ 'nav-black': $route.meta.titleBlack }"
      :style="{
        height: navHeight + 'px',
        paddingTop: statusBarHeight + 'px'
      }"
      v-if="$route.meta.titleNView"
    >
      <van-icon
        class="arrow"
        @click="$router.back()"
        name="arrow"
        size="17.5px"
      />
      <!-- {{ title }} -->
      <div class="right-warp">
        <img
          v-if="!$route.meta.no_home && !['home', 'cart'].includes($route.name)"
          src="@/assets/images/home/home_logo.png"
          @click="goHome"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { statusBarHeight, navHeight, pageTitle, JSBridgeReady } from "@/util/utils";
// import { setScrollInit } from "@/composition/useScroll";
export default {
  name: "NavigationBar",
  props: {
    opacity: {
      type: [String, Number],
      default: "0"
    }
  },
  data() {
    return {
      navHeight,
      statusBarHeight,
      isAlive: true,
    };
  },
  mounted() {
    // JSBridgeReady(() => {
    //   window.AlipayJSBridge.call("onGestureBack", {}, () => {
    //     if (this.isAlive) {
    //       this.goBack();
    //     }
    //   });
    // });
  },
  beforeDestroy() {
    this.isAlive = false;
  },
  computed: {
    title() {
      if (pageTitle) {
        return pageTitle;
      }
      return this.$route.meta.title || "友星商城";
    }
  },
  methods: {
    goHome() {
      this.$router.replace({ path: "/" });
    },
    goBack() {
      if (!window.AlipayJSBridge) {
        this.$router.back();
        return
      }
      if (this.$router.canGoBack()) {
        this.$router.back();
      } else {
        window.AlipayJSBridge.call("closeWindow");
      }
    }
  }
};
</script>
<style scoped lang="scss">
.title-n-view {
  background-color: #fff;
  position: fixed;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  z-index: 10000;
  opacity: 0;
  .nav-bar {
    color: #000;
  }
}
.nav-bar {
  width: 100%;
  color: #fff;
  z-index: 1;
  position: fixed;
  text-align: center;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  .arrow {
    position: absolute;
    left: 12px;
    transform: rotate(180deg);
  }
  .right-warp {
    position: absolute;
    right: 12px;
    display: flex;
    align-items: center;
    > img {
      margin-left: 10px;
      width: 24px;
      height: 24px;
    }
  }
}
.nav-black {
  // color: #000;
  .arrow {
    background-color: rgba($color: #000, $alpha: 0.8);
    border-radius: 50%;
    padding: 5px;
    left: 7px;
  }
  img {
    background-color: rgba($color: #000, $alpha: 0.8);
    border-radius: 50%;
    padding: 1.75px;
    right: 10px;
  }
}
</style>
